// extracted by mini-css-extract-plugin
export default {"node":"organigrammi_node__-5txV","link":"organigrammi_link__8DHiS"};